import {config, QUERY_PARAM_LIMIT} from "../config/utils";

const VERIFY_AUTH_INTERVAL = 1000 * 60 * 5;
const REFRESH_TOKEN_TIMEOUT = 1000 * 60 * 8;

export interface State {
  fn: string[];
  kfn: string[];
}

export const authHandler = () => {
  setInterval(() => {
    if (hasToken()) {
      if (isTokenExpired()) {
        navigateToLogin();
      } else if (isTokenAlmostExpired()) {
        refreshToken()
      }
    }
  }, VERIFY_AUTH_INTERVAL);
}

export const refreshToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  const response = await fetch(
    `${config.server}/auth/refresh-token?refreshToken=${refreshToken}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem("idToken")}`
      }
    }
  );
  const data = await response.json();
  localStorage.setItem("idToken", data.idToken);
  localStorage.setItem("refreshToken", data.refreshToken);
  localStorage.setItem("expire", data.expire ?? "0");
  console.log("Token successfully refreshed.");
}

export const hasToken = () => {
  return !!localStorage.getItem("idToken");
}

export const isTokenExpired = () => {
  const expire = localStorage.getItem("expire") ?? "0";
  return new Date().getTime() > parseInt(expire);
}

export const isTokenAlmostExpired = () => {
  const expire = localStorage.getItem("expire") ?? "0";
  return (new Date().getTime() + REFRESH_TOKEN_TIMEOUT) > parseInt(expire);
}

export const navigateToLogin = () => {
  const state = getStateValues();
  window.location.href = `${config.server}/auth/login?state=${btoa(JSON.stringify(state))}`;
}

export const setStateValues = (
  {
    kfn = [],
    fn = []
  }: State
) => {
  localStorage.setItem("kfn", JSON.stringify([...new Set(kfn)]));
  localStorage.setItem("fn", JSON.stringify([...new Set(fn)]));
}

export const truncateQueryParams = (arr: any[]) => arr.slice(0, QUERY_PARAM_LIMIT);

export const getStateValues = () => {
  return {
    kfn: truncateQueryParams(JSON.parse(localStorage.getItem("kfn") ?? "[]")),
    fn: truncateQueryParams(JSON.parse(localStorage.getItem("fn") ?? "[]"))
  } as State
}